import React, { ComponentType, SVGProps } from 'react'
import Button from '../Button'
import { DoneIcon32 } from '../../icons'
import Dialog from './Dialog'
import DialogContent from './DialogContent'
import DialogFooter from './DialogFooter'

export interface InfoDialogProps {
  title: string
  state: boolean
  onOk: () => void
  onClose: () => void
  okButtonText: string
  okButtonType?: 'button' | 'reset' | 'submit'
  okButtonIcon?: ComponentType<SVGProps<SVGSVGElement>>
  okButtonDisabled?: boolean
  'data-testid': string
  children: React.ReactNode
}

export default function InfoDialog({
  title,
  state,
  onOk,
  onClose,
  okButtonText,
  okButtonType = 'button',
  okButtonIcon: OkButtonIcon = DoneIcon32,
  okButtonDisabled = false,
  'data-testid': testId,
  children
}: Readonly<InfoDialogProps>) {
  const handleOk = () => {
    onOk()
    onClose()
  }

  return (
    <Dialog
      state={state}
      title={title}
      onClose={onClose}
      className="max-w-2xl !p-1 !pt-1.5"
      data-testid={testId}
    >
      <DialogContent
        className="my-2 flex flex-col gap-1"
        data-testid={`${testId}-content`}
      >
        {children}
      </DialogContent>

      <DialogFooter data-testid={`${testId}-footer`}>
        <div
          className="flex flex-col justify-center"
          data-testid={`${testId}-footer-wrapper`}
        >
          <Button
            type={okButtonType}
            variant="brand-primary"
            onClick={handleOk}
            data-testid={`${testId}-ok-button`}
            disabled={okButtonDisabled}
          >
            <OkButtonIcon data-testid={`${testId}-ok-button-icon`} />
            <span className="pl-0.5" data-testid={`${testId}-ok-button-text`}>
              {okButtonText}
            </span>
          </Button>
        </div>
      </DialogFooter>
    </Dialog>
  )
}
